import { useEffect, useState } from 'react';
import { css, cx } from '@eti/styles';
import { price as priceUtil } from '@eti/utils';
import { useTranslation } from '@eti/providers';
import ReactTooltip from 'react-tooltip';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const labelStyles = css`
  display: block;

  & strong {
    font-weight: 700;
    margin-left: 4px;
  }
`;
const genericStyles = css`
  max-width: 240px;
`;
const SeatToolTip = _ref => {
  let {
    id,
    price,
    seat
  } = _ref;
  const {
    t
  } = useTranslation();
  const tooltipSeatLabel = t('Product.SeatMap.Tooltip.Select');
  const tooltipPriceLabel = t('Product.SeatMap.Tooltip.Price');
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [seatId, setSeatId] = useState('');
  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };
    // updating the seatId when id changes to trigger re-render and changes the key of ReactTooltip
    setSeatId(id);
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [screenWidth, id]);
  return /*#__PURE__*/_jsxs(ReactTooltip, {
    className: cx('etiTooltip', genericStyles),
    effect: "solid",
    globalEventOff: "touchstart",
    id: id,
    children: [/*#__PURE__*/_jsxs("span", {
      className: labelStyles,
      children: [tooltipSeatLabel, /*#__PURE__*/_jsx("strong", {
        children: seat
      })]
    }), /*#__PURE__*/_jsxs("span", {
      className: labelStyles,
      children: [tooltipPriceLabel, /*#__PURE__*/_jsx("strong", {
        children: priceUtil.formatPrice(price)
      })]
    })]
  }, `key-${seatId}-${screenWidth}`);
};
export default SeatToolTip;
//# sourceMappingURL=SeatTooltip.js.map